import { Injectable } from '@angular/core';
import { IHttpService } from '../../common/IHttpService';
import { G_ComplainsSuggestionsViewModel } from 'src/app/viewmodels/g-settings/G_ComplainsSuggestionsViewModel';
import { EndpointConfig } from '../../common/EndpointConfig';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ComplainAndSuggestionsService implements IHttpService<G_ComplainsSuggestionsViewModel> {
  private _ep: EndpointConfig;
  constructor(private _client: HttpClient) {
    this._ep = new EndpointConfig('GSettings');
  }

  GetList() {
    return this._client.get(this._ep.getEndpointMethod('GetG_ComplainsSuggestionsList'));
  }

  checkDublication(code) {
    return this._client.post(this._ep.getEndpointMethod('CheckComplainSuggestionDublication'), { Code: code });
  }

  GetById(id: any) {
    return this._client.post(this._ep.getEndpointMethod('GetG_ComplainsSuggestionsServiceById'), { Id: id });
  }
  Post(obj: G_ComplainsSuggestionsViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_ComplainsSuggestionsService'), obj);
  }

  Put(obj: G_ComplainsSuggestionsViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_ComplainsSuggestionsService'), obj);
  }

  Delete(obj: G_ComplainsSuggestionsViewModel) {
    return this._client.post(this._ep.getEndpointMethod('DeleteG_ComplainsSuggestionsService'), obj);
  }
}
